import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicMultiSelectTable, MASK_TEXT_NOWRAP } from "../../../../../../theme/Component/BasicMultiSelecTable";
import { _FixedAssetItem } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../../../../editor/AccountEditor";
import { SelectStoreEditor } from "../../SelectStore.editor";
import { SelectFixedAsset } from "../FixedAsset/SelectFixedAsset";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { DropDown } from "../../../../../../theme/Component/DropDown";
import useModal, { MODAL_md } from "../../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../../theme/Component/Modal";
import { _single, _SystemPropertyOB } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { useZebraPrinter } from "../../../../../../system/zpl/useZebraPrinter";
import { BatchItem, chunkIntoPairs, generateZpl, generateZplBatch, LabelField } from "../../../../../../system/zpl/useZplGenerator";



export const PrintZPLFixedAssetItem = () => {

    // para utilizar este componente debe seguir los siguientes pasos:
    // 1 el programa debe estar corriendo en localhost o en https
    // 2 se debe instalae el programa zadig
    // 3. al executar el programa en como administrador se debe seleccionar las opciones listar todos los dispositivos
    // 4. buscar el dispositivo de la impresora (conectada por usb o red)
    // 5. remplazar el driver y listo

    const { print } = useZebraPrinter();
    const props = useDataBean(_SystemPropertyOB)
    const { instance, bean, setBean, lista, setLista } = useDataBean(_FixedAssetItem)
    const [listaResult, setListaResult] = useState<any>([]);

    const modalPrint = useModal("Confirmar Impresión de Placas", MODAL_md);

    const [response, setResponse] = useState<any>({});
    const paginador = usePaginator();

    useEffect(() => {
        props.instance.getPrinterPropertiesZPL(_single.getAccountID()).then(
            (resp) => {
                console.log(resp)
                props.setBean(resp)
            }
        ).catch(
            err => {
                toast.error("No se pudieron cargar las propiedades del sistema")
            }
        )
    }, [])

    useEffect(() => {
        if (hasValidFilter()) {
            getLista();
        }
    }, [paginador.page]);

    const getLista = () => {
        instance.getFixedAssetItemsByFilterTicket(response.IDFixedAsset, response.Regex, response.IDAccount, response.Store, [], response.TicketCode, paginador.page, 15).then(
            (resp) => {
                resp.List.forEach(element => {
                    const item = element.DataBeanProperties;
                    item.DimensionesEntity = `${item.DimWidth & item.DimHeigth ? `${item.DimWidth} x ${item.DimHeigth}` : "N/A"}`
                    item.ResolveCode = item.LineCode ? `${item.LineCode} - ${item.TicketCode}` : item.TicketCode;
                });
                setLista(resp.List)
                paginador.setPages(resp.NumberOfPages)
            }
        ).catch(
            err => {
                console.log(err)
            }
        );
    }

    //No tocar, ni dios sabe como sirve.... solo gpt sabe como esta funcionando esto pero lo esta haciendo
    const defaultPrintProps = ["Entity", "Name", "SerialNumber", "StoreName", "ResolveCode"];

    const getPrintProps = (printProps: any) => {
        if (!Array.isArray(printProps)) {
            return defaultPrintProps;
        }

        const configuredProps = printProps
            .filter((prop) => typeof prop === "string" && prop.trim() !== "")
            .map((prop) => prop.trim());

        return configuredProps.length > 0 ? configuredProps : defaultPrintProps;
    }

    const valueOrNA = (value: any) => {
        if (value === undefined || value === null || `${value}`.trim() === "") {
            return "N/A";
        }

        return `${value}`;
    }

    const getPrintValue = (printProp: string, item: any, propSys: any) => {
        const data = item.DataBeanProperties ?? {};

        switch (printProp) {
            case "Entity":
                return valueOrNA(propSys.Entity);
            case "SerialNumber":
                return data.SerialNumber ? `S/N : ${data.SerialNumber}` : "N/A";
            case "StoreName":
                return data.StoreName ? `UBICACION : ${data.StoreName}` : "N/A";
            case "TicketCode":
                return data.ResolveCode ? `PLACA : ${data.ResolveCode}` : "N/A";
            default:
                return valueOrNA(data[printProp] ?? propSys[printProp]);
        }
    }

    const buildBatchItems = () => {
        const propSys = props.bean;
        const printProps = getPrintProps(propSys.PrintProps);

        return listaResult.map(item => {
            const fields: LabelField[] = printProps.map((printProp, index) => ({
                x: 0,
                y: 20 + (index * 30),
                font: "A",
                height: propSys.LabelHeigth ?? 15,
                width: propSys.LabelWith ?? 15,
                data: getPrintValue(printProp, item, propSys),
            }));

            return {
                fields,
                qrData: propSys.PrintQR ? `Placa: ${item.DataBeanProperties.TicketCode}` : undefined
            };
        });
    };

    const PrintPlates = async () => {
        //tampoco tocar, ni dios ni gpt sabe como esta funcionando esto pero lo esta haciendo (creado antes de la era de IA)
        const propsSys = props.bean;
        const baseItems = buildBatchItems();

        const expanded: BatchItem[] = [];
        listaResult.forEach((orig, idx) => {
            for (let i = 0; i < orig.quantity; i++) {
                expanded.push(baseItems[idx]);
            }
        });

        if (propsSys.TicketUnitary) {
            for (const it of expanded) {
                const cmd = generateZpl(
                    it.fields,
                    "center",
                    it.qrData,
                    { qrX: 10, qrY: 50, qrMagnification: propsSys.QRWH ?? 3, gap: 10 },
                    { dpi: propsSys.ZPLDPI, maxWidthInches: propsSys.ZPLWidthInches, darkness: propsSys.Darkness, maxChars: propsSys.MaxCharacters }
                );
                await print(cmd);
            }
        } else {
            const pairs = chunkIntoPairs(expanded);
            for (const pair of pairs) {
                const cmd = generateZplBatch(
                    pair,
                    { qrX: 10, qrY: 50, qrMagnification: propsSys.QRWH ?? 3, gap: 10 },
                    { dpi: propsSys.ZPLDPI, maxWidthInches: propsSys.ZPLWidthInches, darkness: propsSys.Darkness, maxChars: propsSys.MaxCharacters }
                );
                await print(cmd);
            }
        }

        modalPrint.close();
    };

    const head = [
        { title: 'ID', property: 'IDItem', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Placa', property: 'ResolveCode', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Disponibilidad', property: 'StateName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Responsable', property: 'ResponsibleName', visible: true },
        { title: 'Ubicación', property: 'StoreName', visible: true },
        { title: 'Estado del Bien', property: 'FixedAssetStateName', visible: true },
        { title: 'Serial', property: 'SerialNumber', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Tipo Doc', property: 'Mnemonic', visible: true },
        { title: 'Num Doc', property: 'Consecutive', visible: true },
    ]

    const hasValidFilter = () => {
        return Object.values(response).some(value =>
            value !== undefined &&
            value !== null &&
            !(typeof value === 'string' && value.trim() === '')
        );
    };

    const eventChange = (e: any) => {

        if (e.id === 1) {
            modalPrint.open()
        }

    }

    const actionsDropDown = [
        { id: 1, name: 'Imprimir etiquetas en impresora ZPL', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={eventChange}></DropDown>
                </div>
            </div>
        )
    }

    const updateTaxCodeList = (newListaResult: any[]) => {
        setListaResult(prev => {
            const merged = newListaResult.map(item => {
                const found = prev.find(x => x.DataBeanProperties.IDItem === item.DataBeanProperties.IDItem);
                return {
                    ...item,
                    quantity: found?.quantity ?? 1
                };
            });
            return merged;
        });
    };



    return (
        <BasicPage titulo="Impresión de Placas ZPL">
            <div className="row">
                <div className="col-md-6">
                    <SelectFixedAsset idSelector={response.IDFixedAsset} onChange={(e) => { setResponse({ ...response, "IDFixedAsset": e }) }} />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className='form-control' value={response.Regex} onChange={(e) => { setResponse({ ...response, "Regex": e.target.value }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={response.IDAccount} label="Responsable" onChange={(e) => { setResponse({ ...response, "IDAccount": e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <SelectStoreEditor idSelector={response.Store} onChange={(e) => { setResponse({ ...response, "Store": e.IDStore }) }} />
                </div>
                <div className="col-md-6">
                    <label>Placa</label>
                    <input type="text" name="ticketCode" className="form-control" value={response.TicketCode} onChange={(e) => {
                        const valor = e.target.value ? Number(e.target.value) : null;
                        setResponse({ ...response, TicketCode: valor })
                    }} />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton
                        eventClick={() => {
                            if (hasValidFilter()) {
                                getLista();
                            } else {
                                toast.error("Por favor, ingrese al menos un filtro de búsqueda.");
                            }
                        }}
                        icon='ri-search-line'
                    >
                        {"Buscar"}
                    </BasicButton>

                </div>
                <div className="col-md-12">
                    <BasicMultiSelectTable
                        headButtons={buttons()}
                        keyId="IDItem"
                        clearnotListBody
                        setRowBean={setBean}
                        body={lista}
                        bodyResult={listaResult}
                        head={head}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        updateValues={({ bodyResult }) => { updateTaxCodeList(bodyResult) }}
                    />
                </div>

                <div className="col-md-12">
                    <Modal
                        modal={modalPrint.modal}
                        updateModal={modalPrint.setModal}
                        eventModal={PrintPlates}
                    >
                        <div className="row">
                            <label>¿Desea imprimir las siguientes placas?</label>

                            {listaResult.length > 0 ? (
                                listaResult.map(item => {
                                    const { IDItem, TicketCode, Name } = item.DataBeanProperties;
                                    return (
                                        <div key={IDItem} className="col-12 mb-2">
                                            <div className="row align-items-center">
                                                <div className="col-7 text-truncate">
                                                    {TicketCode} – {Name}
                                                </div>
                                                <div className="col-5">
                                                    <label className="mb-0">Cantidad:</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        min={1}
                                                        value={item.quantity}
                                                        onChange={e => {
                                                            const q = Math.max(1, parseInt(e.target.value) || 1);
                                                            setListaResult(prev =>
                                                                prev.map(x =>
                                                                    x.DataBeanProperties.IDItem === IDItem
                                                                        ? { ...x, quantity: q }
                                                                        : x
                                                                )
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="text-muted">No hay placas seleccionadas.</div>
                            )}
                        </div>
                    </Modal>

                </div>
            </div>
        </BasicPage>
    )
}
